import * as tslib_1 from "tslib";
import { takeUntil } from 'rxjs/operators';
import { select, Store } from '@ngrx/store';
import * as auth from './../../actions/auth.actions';
import * as fromAuth from './../../reducers';
import { ContainerBase } from '../../../core/base/container-base';
var LoginContainer = /** @class */ (function (_super) {
    tslib_1.__extends(LoginContainer, _super);
    function LoginContainer(store) {
        var _this = _super.call(this) || this;
        _this.store = store;
        _this.error$ = store.pipe(select(fromAuth.getLoginPageError), takeUntil(_this.destroyed$));
        _this.loggingIn$ = store.pipe(select(fromAuth.isLoginWorking), takeUntil(_this.destroyed$));
        return _this;
        // remove header space
        //this.store.dispatch(new status.SetHeader(false));
    }
    LoginContainer.prototype.login = function (event) {
        this.store.dispatch(new auth.Login(event));
    };
    return LoginContainer;
}(ContainerBase));
export { LoginContainer };
